var _os = 'unknown OS'
var _browser = 'unknown browser'
var _version = 'unknown version'

;(function() {
	var dataOS = {
		iPhone: {
			string: navigator.userAgent,
			key: 'iPhone',
		},
		iPad: {
			string: navigator.userAgent,
			key: 'iPad',
		},
		iPod: {
			string: navigator.userAgent,
			key: 'iPod',
		},
		Android: {
			string: navigator.userAgent,
			key: 'Android',
		},
		WP: {
			string: navigator.userAgent,
			key: 'Windows Phone',
		},
		Windows: {
			string: navigator.platform,
			key: 'Win',
		},
		Linux: {
			string: navigator.platform,
			key: 'Linux',
		},
		Mac: {
			string: navigator.platform,
			key: 'Mac',
		},
	}

	var dataBrowser = {
		IEEdge: {
			string: navigator.userAgent,
			key: 'Edge',
			versionKey: 'Edge',
		},
		Wechat: {
			string: navigator.userAgent,
			key: 'MicroMessenger',
			versionKey: 'MicroMessenger',
		},
		QQBrowser: {
			string: navigator.userAgent,
			key: 'QQBrowser',
			versionKey: 'QQBrowser',
		},
		QQ: {
			string: navigator.userAgent,
			key: 'QQ',
			versionKey: 'QQ',
		},
		Chrome: {
			string: navigator.userAgent,
			key: 'Chrome',
			versionKey: 'Chrome',
		},
		Safari: {
			string: navigator.vendor,
			key: 'Apple',
			versionKey: 'Version',
		},
		Firefox: {
			string: navigator.userAgent,
			key: 'Firefox',
			versionKey: 'Firefox',
		},
		IE: {
			string: navigator.userAgent,
			key: 'MSIE',
			versionKey: 'MSIE',
		},
		Mozilla: {
			string: navigator.userAgent,
			key: 'Gecko',
			versionKey: 'rv',
		},
	}

	var str, key, versionKey, index

	for (var os in dataOS) {
		str = dataOS[os].string || ''
		key = dataOS[os].key
		if (str.indexOf(key) >= 0) {
			_os = os
			break
		}
	}

	for (var browser in dataBrowser) {
		str = dataBrowser[browser].string || ''
		key = dataBrowser[browser].key
		if (str.indexOf(key) >= 0) {
			_browser = browser

			// search version
			versionKey = dataBrowser[browser].versionKey
			index = str.indexOf(versionKey)
			if (index >= 0) {
				index += versionKey.length + 1
				_version = parseFloat(str.substring(index))
			}

			break
		}
	}
})()

export let Client = {
	os: _os,
	browser: _browser,
	version: _version,

	isIE: _browser === 'IE',
	isIE7: _browser === 'IE' && _version >= 7 && _version < 8,

	isIE7Plus: _browser === 'IE' && _version >= 7,
	isIE8Plus: _browser === 'IE' && _version >= 8,
	isIE9Plus: _browser === 'IE' && _version >= 9,

	isWindows: _os === 'Windows',
	isLinux: _os === 'Linux',
	isMac: _os === 'Mac',
	isMobile: _os !== 'Windows' && _os !== 'Linux' && _os !== 'Mac',

	isAndroid: _os === 'Android',
	isIOS: _os === 'iPhone' || _os === 'iPad' || _os === 'iPod',
	isWindowsPhone: _os === 'WP',

	isWechat: _browser === 'Wechat',
	isQQBrowser: _browser === 'QQBrowser',
	isQQ: _browser === 'QQ',

	// only for enterprise deployment
	isEnterprise: window.PageInfo && window.PageInfo.IS_ENTERPRISE,
}
